import { MainPointOutType, pointPutTypeOrder } from '../../@types/rule-type';
export default class ErrorPointCreator {
    createErrorPointsInfo(newErrorPoints) {
        const finalErrorAnalysis = {};
        const aiErrorPointsInfo = {};
        const lintErrorPointsInfo = {};
        for (const errorPoint of newErrorPoints) {
            finalErrorAnalysis[errorPoint.index] = {
                ...(finalErrorAnalysis[errorPoint.index] || {}),
                [errorPoint.type]: [
                    ...(finalErrorAnalysis[errorPoint.index]?.[errorPoint.type] || []),
                    errorPoint.order,
                ],
            };
            if (errorPoint.type === MainPointOutType.AI) {
                if (!aiErrorPointsInfo.hasOwnProperty(errorPoint.order)) {
                    aiErrorPointsInfo[errorPoint.order] = errorPoint.resultHtmlInfo;
                }
            }
            if (errorPoint.type === MainPointOutType.LINT) {
                if (!lintErrorPointsInfo.hasOwnProperty(errorPoint.order)) {
                    lintErrorPointsInfo[errorPoint.order] = errorPoint.resultHtmlInfo;
                }
            }
        }
        return { finalErrorAnalysis, aiErrorPointsInfo, lintErrorPointsInfo };
    }
    createErrorPoint(ProofreadingPoints) {
        return ProofreadingPoints.createProofreadingPoints();
    }
    mergeErrorPoints(aiErrorPoints, lintErrorPoints) {
        const mergedErrorPoints = lintErrorPoints;
        for (const aiErrorPoint of aiErrorPoints) {
            mergedErrorPoints.push(aiErrorPoint);
        }
        return mergedErrorPoints.sort((a, b) => a.index - b.index);
    }
    /**
     *
     * @param errorPoints
     * @returns {ErrorPointInfo[]}
     * 重複するエラーポイントを優先順位を考慮して削除
     */
    removeDuplicateErrorPoints(errorPoints) {
        const uniqueErrorPoints = [];
        let lastIndex = -1;
        for (const errorPoint of errorPoints) {
            if (lastIndex < errorPoint.index) {
                uniqueErrorPoints.push(errorPoint);
                lastIndex = errorPoint.index + errorPoint.range;
            }
            else {
                const lastErrorPoint = uniqueErrorPoints[uniqueErrorPoints.length - 1];
                if (lastErrorPoint.type === MainPointOutType.LINT && errorPoint.type === MainPointOutType.LINT) {
                    if (lastErrorPoint.resultHtmlInfo.ruleId === errorPoint.resultHtmlInfo.ruleId) {
                        if (uniqueErrorPoints[uniqueErrorPoints.length - 1].hasOwnProperty('addOrder')) {
                            uniqueErrorPoints[uniqueErrorPoints.length - 1].addOrder?.push(errorPoint.order);
                        }
                        else {
                            uniqueErrorPoints[uniqueErrorPoints.length - 1].addOrder = [lastErrorPoint.order, errorPoint.order];
                        }
                    }
                }
                if (this.checkPriority(errorPoint, lastErrorPoint)) {
                    uniqueErrorPoints[uniqueErrorPoints.length - 1] = errorPoint;
                    lastIndex = errorPoint.index + errorPoint.range;
                }
            }
        }
        return uniqueErrorPoints;
    }
    /**
     *
     * @param errorPoint
     * @param lastErrorPoint
     * @returns true: errorPointの方が優先順位が高い
     *
     * 優先順位を比較
     */
    checkPriority(errorPoint, lastErrorPoint) {
        const sPriority = this.getPriorityOrder(lastErrorPoint);
        const iPriority = this.getPriorityOrder(errorPoint);
        return iPriority < sPriority;
    }
    /**
     *
     * @param errorPoint
     * @returns タイプごとの優先順位を取得
     */
    getPriorityOrder(errorPoints) {
        const mainType = errorPoints.type;
        if (mainType === MainPointOutType.LINT) {
            console.log(pointPutTypeOrder[errorPoints.resultHtmlInfo.ruleType]);
            return pointPutTypeOrder[errorPoints.resultHtmlInfo.ruleType];
        }
        return pointPutTypeOrder[errorPoints.type];
    }
}
